// extracted by mini-css-extract-plugin
export var externalLink = "_8t-0";
export var internalLinkLabel = "_8t-1";